import { LineChart as AntdLineChart } from "@empglabs/backoffice-ui-kit"

const LineChart = props => {
  return <AntdLineChart {...props} />
}

export default LineChart
